module.exports = __webpack_public_path__ + "img/risks-low-energy.ee358fb8.svg";